import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import { AppLang } from '../State/App/AppModel'

export const useCustomTranslation = (): { t: TFunction; selectedAppLanguage: AppLang } => {
  const { t, i18n } = useTranslation()

  return { t, selectedAppLanguage: i18n.language as AppLang }
}
